import React, { Component } from 'react';
import {
    Input,
    Button,
    Row,
    Col,
    Label,
    InputGroup,
    InputGroupAddon,
    InputGroupText
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faTrashAlt, faSpinner } from '@fortawesome/free-solid-svg-icons'
import OpportunitiesNotesForm from './OpportunitiesNotesForm';
import ConfirmButton from '../../Modal/ConfirmButton';
import { isSaleOpportunityValid } from '../opportunityValidation';
class EditOpportunity extends Component {

    render() {

        return (<tr id={`sales-opportunity-${this.props.row.ID}`}>
            <td colSpan={12}>
                <Row>
                    <Col md={3}>
                        <Row className="mb-2">
                            <Col>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>WA</InputGroupText>
                                    </InputGroupAddon>
                                    <Input
                                        aria-label="WA number"
                                        placeholder="Number"
                                        name="waNumber"
                                        maxLength={100}
                                        value={this.props.editOpportunity.waNumber + ''}
                                        onChange={e => this.props.onChange(e, 'edit')}
                                    />
                                </InputGroup>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <Input
                                    placeholder="Opportunity Name"
                                    name="name"
                                    value={this.props.editOpportunity.name + ''}
                                    onChange={e => this.props.onChange(e, 'edit')} />
                            </Col>
                        </Row>
                        {/* {this.props.contacts != null && this.props.contacts.length > 0 && */}
                            <Row className="mb-2">
                                <Col>
                                    <Input
                                        type="select"
                                        name="contactLinkedID"
                                        onChange={e => this.props.onChange(e, 'edit')}
                                        value={this.props.editOpportunity.contactLinkedID}
                                    >
                                        <option value="">Contact</option>
                                        {this.props.editOpportunity.primaryBusinessName !== '' && this.props.contacts.map(contact => {
                                            if (contact.children != null && contact.children['Contact Name'] != null) {
                                                return (
                                                    <option key={contact.linkedID} value={contact.linkedID}>
                                                        {contact.children['Contact Name']}
                                                        {!contact.active ? ' (Inactive)' : ''}
                                                    </option>
                                                )
                                            } else {
                                                return null;
                                            }
                                        })}
                                    </Input>
                                </Col>
                            </Row>
                        {/* } */}
                        <Row className="mb-2">
                            <Col>
                                <Input
                                    type="date"
                                    name="date"
                                    value={String(this.props.editOpportunity.date).substring(0, 10) + ''}
                                    onChange={e => this.props.onChange(e, 'edit')} />
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <Input
                                    type="select"
                                    name="typeID"
                                    value={this.props.editOpportunity.typeID}
                                    onChange={e => this.props.onChange(e, 'edit')}>
                                    <option value={0}>Type</option>
                                    {this.props.types.map(type => (
                                        <option key={type.ID} value={type.ID}>{type.Opportunity}</option>
                                    ))}
                                </Input>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <Input
                                    type="select"
                                    name="statusID"
                                    value={this.props.editOpportunity.statusID}
                                    onChange={e => this.props.onChange(e, 'edit')}>
                                    <option value={0}>Status</option>
                                    {(this.props.selectedStatuses || this.props.statuses).map(status => (
                                        <option key={status.ID} value={status.ID}>{status.Opportunity}</option>
                                    ))}
                                </Input>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <Input
                                    type="select"
                                    name="stageID"
                                    value={this.props.editOpportunity.stageID}
                                    onChange={e => this.props.onChange(e, 'edit')}>
                                    <option value={0}>Stage</option>
                                    {this.props.stages.map(stage => (
                                        <option key={stage.ID} value={stage.ID}>{stage.Opportunity}</option>
                                    ))}
                                </Input>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <Input type="select" name="sourceID" value={this.props.editOpportunity.sourceID || 0} onChange={e => this.props.onChange(e, 'edit')}>
                                    <option value={0}>Source</option>
                                    {this.props.sources.map(source => <option key={source.ID} value={source.ID}>{source.Opportunity}</option>)}
                                </Input>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={3}>
                        <Row className="mb-2">
                            <Col>
                                <Input
                                    type="select"
                                    name="assigneeUserID"
                                    value={this.props.editOpportunity.assigneeUserID}
                                    onChange={e => this.props.onChange(e, 'edit')}>
                                    <option value={0}>Assignee</option>
                                    {this.props.users.map(user => (
                                        <option key={user.Auth0} value={user.Auth0}>{user['Full Name']}</option>
                                    ))}
                                </Input>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <Input
                                    placeholder="Assignee (Other)"
                                    name="assigneeUserOther"
                                    value={this.props.editOpportunity.assigneeUserOther + ''}
                                    onChange={e => this.props.onChange(e, 'edit')} />
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <Input
                                    type="select"
                                    name="salesRepUserID"
                                    value={this.props.editOpportunity.salesRepUserID}
                                    onChange={e => this.props.onChange(e, 'edit')}>
                                    <option value={0}>Sales Rep</option>
                                    {this.props.users.map(user => (
                                        <option key={user.Auth0} value={user.Auth0}>{user['Full Name']}</option>
                                    ))}
                                </Input>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <Input
                                    placeholder="Sales Rep (Other)"
                                    name="salesRepUserOther"
                                    value={this.props.editOpportunity.salesRepUserOther + ''}
                                    onChange={e => this.props.onChange(e, 'edit')} />
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <Input
                                    placeholder="Opportunity Amount"
                                    name="opportunityAmount"
                                    value={this.props.editOpportunity.opportunityAmount != null ? this.props.editOpportunity.opportunityAmount : ''}
                                    onChange={e => this.props.onChange(e, 'edit')} />
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col className="pl-5">
                                <Label>
                                    <Input
                                        type="checkbox"
                                        name="active"
                                        checked={this.props.editOpportunity.active}
                                        onChange={e => this.props.onChange(e, 'edit')} />
                                    Active</Label>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <Input
                                    placeholder="Commission Notes"
                                    type="textarea"
                                    rows={10}
                                    name="commissionNotes"
                                    value={this.props.editOpportunity.commissionNotes != null ? this.props.editOpportunity.commissionNotes : ''}
                                    onChange={e => this.props.onChange(e, 'edit')} />
                            </Col>
                        </Row>
                    </Col>
                    <Col md={3}>
                        <Row className="mb-2">
                            <Col>
                                <Input
                                    type="select"
                                    name="maintenanceRequirementStatus"
                                    value={this.props.editOpportunity.maintenanceRequirementStatus}
                                    onChange={e => this.props.onChange(e, 'edit')}>
                                    <option value="">Maint. Requirement Status</option>
                                    <option>Maint - Optional</option>
                                    <option>Maint - Mandatory</option>
                                    <option>Maint - Not Offered</option>
                                </Input>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <Input
                                    type="select"
                                    name="maintenanceAcceptanceStatus"
                                    value={this.props.editOpportunity.maintenanceAcceptanceStatus}
                                    onChange={e => this.props.onChange(e, 'edit')}>
                                    <option value="">Maint. Acceptance Status</option>
                                    <option>Maint - N/A</option>
                                    <option>Maint - Offered</option>
                                    <option>Maint - Accepted</option>
                                    <option>Maint - Declined</option>
                                </Input>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <Input
                                    type="date"
                                    name="maintenanceEndDate"
                                    value={this.props.editOpportunity.maintenanceEndDate != null ? this.props.editOpportunity.maintenanceEndDate : ''}
                                    onChange={e => this.props.onChange(e, 'edit')} />
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <Input
                                    placeholder='Maintenance Notes'
                                    type="textarea"
                                    rows={10}
                                    name="maintenanceNotes"
                                    value={this.props.editOpportunity.maintenanceNotes}
                                    onChange={e => this.props.onChange(e, 'edit')}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <Input
                                    placeholder='Next Steps'
                                    name="nextSteps"
                                    value={this.props.editOpportunity.nextSteps}
                                    onChange={e => this.props.onChange(e, 'edit')}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col className="text-right mt-2">
                                <Button
                                    disabled={!isSaleOpportunityValid(this.props.editOpportunity)}
                                    className="mx-1"
                                    color="success"
                                    onClick={this.props.handleEdit}
                                    title="Edit Opportunity"
                                >
                                    <FontAwesomeIcon icon={faCheck} />
                                </Button>
                                <ConfirmButton
                                    className='mx-2'
                                    color="danger"
                                    onClick={() => this.props.onDelete(this.props.row.ID)}
                                    title="Delete"
                                ><FontAwesomeIcon icon={this.props.loading && this.props.editID === this.props.row.ID ? faSpinner : faTrashAlt} /></ConfirmButton>
                                <Button className="mx-1" color="secondary" onClick={this.props.handleCancel} title="Cancel">
                                    <FontAwesomeIcon icon={faTimes} />
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={3} className='border-left border-dark'>
                        <Row className="mb-2">
                            <Col>
                                <OpportunitiesNotesForm  {...this.props} via="EditOpportunity" />
                            </Col>
                        </Row>
                        {/* <hr />
                        <Row className="mb-2">
                            <Col>
                                <Input
                                    placeholder='Notes'
                                    type="textarea"
                                    rows={4}
                                    name="notes"
                                    value={this.props.editOpportunity.notes}
                                    onChange={e => this.props.onChange(e, 'edit')}
                                />
                            </Col>
                        </Row> */}

                    </Col>
                </Row>
            </td>
        </tr>
        )
    }
}

export default EditOpportunity;
